import { useMutation } from "@apollo/client";
import { REQUEST_PASSWORD_RESET, RESET_PASSWORD } from "../services/apollo/mutations/userMutations"; 

export const usePasswordReset = () => {
  // Mutation for requesting a password reset
  const [requestPasswordReset, { loading: requestLoading, error: requestError, data: requestData }] = useMutation(REQUEST_PASSWORD_RESET);

  // Mutation for resetting the password
  const [resetPassword, { loading: resetLoading, error: resetError, data: resetData }] = useMutation(RESET_PASSWORD);

  // Function to handle the password reset request
  const handleRequestPasswordReset = async (email) => {
    try {
      await requestPasswordReset({ variables: { email } });
      return requestData;
    } catch (error) {
      console.error("Error requesting password reset:", error);
      throw error;
    }
  };

  // Function to handle the actual password reset
  const handleResetPassword = async (token, password) => {
    try {
      await resetPassword({ variables: { token, password } });
      return resetData;
    } catch (error) {
      console.error("Error resetting password:", error);
      throw error;
    }
  };

  // Returning the functions and state variables
  return {
    handleRequestPasswordReset,
    handleResetPassword,
    requestLoading,
    requestError,
    requestData,
    resetLoading,
    resetError,
    resetData,
  };
};
